import { Note } from "./note.model";

export class Notebook {
  id: number;
  organization : string;
  pages : Note[];

  constructor() {
    this.id = 0;
    this.organization  = "";
    this.pages = [];
  }
}
